// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.idg-map-marker{cursor:pointer}`, "",{"version":3,"sources":["webpack://./resources/assets/js/components/IDG/MapMarker/MapMarker.scss"],"names":[],"mappings":"AAAA,gBACI,cAAA","sourcesContent":[".idg-map-marker {\n    cursor: pointer;\n    //transition: width 0.1s, height 0.1s;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
